import { gql } from '@apollo/client'

export const GET_CUSTOM_FIELDS = gql`
  query getCustomFieldSets(
    $params: CustomFieldSetsParams!
    $fieldValueParams: CustomFieldValuesParams!
    $fieldsParams: CustomFieldsParams!
  ) {
    getCustomFieldSets(params: $params) {
      id
      heading
      help_text
      customFields(params: $fieldsParams) {
        id
        choices
        input_type
        display_name
        required
        retailer_permission
        customFieldValues(params: $fieldValueParams) {
          id
          value
        }
      }
    }
  }
`
